/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@ng-bootstrap/ng-bootstrap/tooltip/tooltip';
import * as i2 from '@ng-bootstrap/ng-bootstrap/tooltip/tooltip-config';
import * as i3 from '@angular/router';
import * as i4 from '@angular/common';
import * as i5 from '../../../app/menu/menu.component';
import * as i6 from '../../../app/menu/menu.service';
import * as i7 from '../../../app/authentication/authentication';
import * as i8 from '../../../app/config/app.config';
const styles_MenuComponent:any[] = ([] as any[]);
export const RenderType_MenuComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_MenuComponent,data:{}});
function View_MenuComponent_2(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(16777216,(null as any),(null as any),8,'a',[['placement',
      'right']],[[8,'id',0],[1,'target',0],[8,'href',4]],[[(null as any),'click']],
      (_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>i0.ɵnov(_v,2).onClick($event.button,$event.ctrlKey,
              $event.metaKey,$event.shiftKey)) !== false);
          ad = (pd_0 && ad);
        }
        if (('click' === en)) {
          const pd_1:any = ((<any>_co.onMenuClicked((<any>_v.parent).context.$implicit.Title)) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },(null as any),(null as any))),i0.ɵdid(212992,(null as any),0,i1.NgbTooltip,
      [i0.ElementRef,i0.Renderer2,i0.Injector,i0.ComponentFactoryResolver,i0.ViewContainerRef,
          i2.NgbTooltipConfig,i0.NgZone],{placement:[0,'placement'],ngbTooltip:[1,
          'ngbTooltip']},(null as any)),i0.ɵdid(671744,[[2,4]],0,i3.RouterLinkWithHref,
      [i3.Router,i3.ActivatedRoute,i4.LocationStrategy],{routerLink:[0,'routerLink']},
      (null as any)),(_l()(),i0.ɵted((null as any),['\n                '])),(_l()(),
      i0.ɵeld(0,(null as any),(null as any),0,'i',([] as any[]),[[1,'class',0]],(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i0.ɵted((null as any),
      [' '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'span',[['class','span-gpis']],
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i0.ɵted((null as any),['',''])),(_l()(),i0.ɵted((null as any),['\n            '])),
      (_l()(),i0.ɵand(0,(null as any),(null as any),0))],(_ck,_v) => {
    const currVal_3:any = 'right';
    const currVal_4:any = i0.ɵinlineInterpolate(1,'',(<any>_v.parent).context.$implicit.Title,
        '');
    _ck(_v,1,0,currVal_3,currVal_4);
    const currVal_5:any = (<any>_v.parent).context.$implicit.Url;
    _ck(_v,2,0,currVal_5);
  },(_ck,_v) => {
    const currVal_0:any = (<any>_v.parent).context.$implicit.Id;
    const currVal_1:any = i0.ɵnov(_v,2).target;
    const currVal_2:any = i0.ɵnov(_v,2).href;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2);
    const currVal_6:any = (<any>_v.parent).context.$implicit.IconClass;
    _ck(_v,4,0,currVal_6);
    const currVal_7:any = (<any>_v.parent).context.$implicit.Title;
    _ck(_v,7,0,currVal_7);
  });
}
function View_MenuComponent_3(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(16777216,(null as any),(null as any),7,'a',[['href',
      '#'],['placement','right']],[[8,'id',0]],[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.openMenuList((<any>_v.parent).context.$implicit)) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),i0.ɵdid(212992,(null as any),0,i1.NgbTooltip,[i0.ElementRef,
      i0.Renderer2,i0.Injector,i0.ComponentFactoryResolver,i0.ViewContainerRef,i2.NgbTooltipConfig,
      i0.NgZone],{placement:[0,'placement'],ngbTooltip:[1,'ngbTooltip']},(null as any)),
      (_l()(),i0.ɵted((null as any),['\n                '])),(_l()(),i0.ɵeld(0,(null as any),
          (null as any),0,'i',([] as any[]),[[1,'class',0]],(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i0.ɵted((null as any),[' '])),(_l()(),
          i0.ɵeld(0,(null as any),(null as any),1,'span',[['class','span-gpis']],(null as any),
              (null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵted((null as any),
          ['',''])),(_l()(),i0.ɵted((null as any),['\n            '])),(_l()(),i0.ɵand(0,
          (null as any),(null as any),0))],(_ck,_v) => {
    const currVal_1:any = 'right';
    const currVal_2:any = i0.ɵinlineInterpolate(1,'',(<any>_v.parent).context.$implicit.Title,
        '');
    _ck(_v,1,0,currVal_1,currVal_2);
  },(_ck,_v) => {
    const currVal_0:any = (<any>_v.parent).context.$implicit.Id;
    _ck(_v,0,0,currVal_0);
    const currVal_3:any = (<any>_v.parent).context.$implicit.IconClass;
    _ck(_v,3,0,currVal_3);
    const currVal_4:any = (<any>_v.parent).context.$implicit.Title;
    _ck(_v,6,0,currVal_4);
  });
}
function View_MenuComponent_4(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),15,'li',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),i0.ɵdid(1720320,
      (null as any),2,i3.RouterLinkActive,[i3.Router,i0.ElementRef,i0.Renderer2,i0.ChangeDetectorRef],
      {routerLinkActive:[0,'routerLinkActive']},(null as any)),i0.ɵqud(603979776,3,
      {links:1}),i0.ɵqud(603979776,4,{linksWithHrefs:1}),i0.ɵpad(1),(_l()(),i0.ɵted((null as any),
      ['\n                    '])),(_l()(),i0.ɵeld(16777216,(null as any),(null as any),
      8,'a',[['placement','right']],[[8,'id',0],[1,'target',0],[8,'href',4]],[[(null as any),
          'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>i0.ɵnov(_v,8).onClick($event.button,$event.ctrlKey,
              $event.metaKey,$event.shiftKey)) !== false);
          ad = (pd_0 && ad);
        }
        if (('click' === en)) {
          const pd_1:any = ((<any>_co.onMenuClicked(_v.context.$implicit.Title)) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },(null as any),(null as any))),i0.ɵdid(212992,(null as any),0,i1.NgbTooltip,
      [i0.ElementRef,i0.Renderer2,i0.Injector,i0.ComponentFactoryResolver,i0.ViewContainerRef,
          i2.NgbTooltipConfig,i0.NgZone],{placement:[0,'placement'],ngbTooltip:[1,
          'ngbTooltip']},(null as any)),i0.ɵdid(671744,[[4,4],[2,4]],0,i3.RouterLinkWithHref,
      [i3.Router,i3.ActivatedRoute,i4.LocationStrategy],{routerLink:[0,'routerLink']},
      (null as any)),(_l()(),i0.ɵted((null as any),['\n                        '])),
      (_l()(),i0.ɵeld(0,(null as any),(null as any),0,'i',([] as any[]),[[1,'class',
          0]],(null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵted((null as any),
          [' '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'span',[['class',
          'span-gpis']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['',''])),(_l()(),i0.ɵted((null as any),['\n                    '])),
      (_l()(),i0.ɵted((null as any),['\n                ']))],(_ck,_v) => {
    const currVal_0:any = _ck(_v,4,0,'active');
    _ck(_v,1,0,currVal_0);
    const currVal_4:any = 'right';
    const currVal_5:any = i0.ɵinlineInterpolate(1,'',(<any>_v.parent).context.$implicit.Title,
        '');
    _ck(_v,7,0,currVal_4,currVal_5);
    const currVal_6:any = _v.context.$implicit.Url;
    _ck(_v,8,0,currVal_6);
  },(_ck,_v) => {
    const currVal_1:any = _v.context.$implicit.Id;
    const currVal_2:any = i0.ɵnov(_v,8).target;
    const currVal_3:any = i0.ɵnov(_v,8).href;
    _ck(_v,6,0,currVal_1,currVal_2,currVal_3);
    const currVal_7:any = _v.context.$implicit.IconClass;
    _ck(_v,10,0,currVal_7);
    const currVal_8:any = _v.context.$implicit.Title;
    _ck(_v,13,0,currVal_8);
  });
}
function View_MenuComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),22,'ul',[['class',
      'nav nav-pills nav-stacked side-navigation']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i0.ɵted((null as any),['\n        '])),
      (_l()(),i0.ɵeld(0,(null as any),(null as any),19,'li',([] as any[]),(null as any),
          (null as any),(null as any),(null as any),(null as any))),i0.ɵdid(278528,
          (null as any),0,i4.NgClass,[i0.IterableDiffers,i0.KeyValueDiffers,i0.ElementRef,
              i0.Renderer],{ngClass:[0,'ngClass']},(null as any)),i0.ɵpod({'menu-list':0,
          'nav-active':1}),i0.ɵdid(1720320,(null as any),2,i3.RouterLinkActive,[i3.Router,
          i0.ElementRef,i0.Renderer2,i0.ChangeDetectorRef],{routerLinkActive:[0,'routerLinkActive']},
          (null as any)),i0.ɵqud(603979776,1,{links:1}),i0.ɵqud(603979776,2,{linksWithHrefs:1}),
      i0.ɵpad(1),(_l()(),i0.ɵted((null as any),['\n            '])),(_l()(),i0.ɵand(16777216,
          (null as any),(null as any),1,(null as any),View_MenuComponent_2)),i0.ɵdid(16384,
          (null as any),0,i4.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),(_l()(),i0.ɵted((null as any),['\n\n            '])),(_l()(),
          i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MenuComponent_3)),
      i0.ɵdid(16384,(null as any),0,i4.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),['\n\n            '])),
      (_l()(),i0.ɵeld(0,(null as any),(null as any),4,'ul',[['class','child-list'],
          ['style','display: none;padding-left:10px;']],[[4,'display',(null as any)]],
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵted((null as any),
          ['\n                '])),(_l()(),i0.ɵand(16777216,(null as any),(null as any),
          1,(null as any),View_MenuComponent_4)),i0.ɵdid(802816,(null as any),0,i4.NgForOf,
          [i0.ViewContainerRef,i0.TemplateRef,i0.IterableDiffers],{ngForOf:[0,'ngForOf']},
          (null as any)),(_l()(),i0.ɵted((null as any),['\n            '])),(_l()(),
          i0.ɵted((null as any),['\n        '])),(_l()(),i0.ɵted((null as any),['\n    ']))],
      (_ck,_v) => {
        const currVal_0:any = _ck(_v,4,0,_v.context.$implicit.SubItems,_v.context.$implicit.Open);
        _ck(_v,3,0,currVal_0);
        const currVal_1:any = _ck(_v,8,0,'active');
        _ck(_v,5,0,currVal_1);
        const currVal_2:boolean = !_v.context.$implicit.SubItems;
        _ck(_v,11,0,currVal_2);
        const currVal_3:any = _v.context.$implicit.SubItems;
        _ck(_v,14,0,currVal_3);
        const currVal_5:any = _v.context.$implicit.SubItems;
        _ck(_v,19,0,currVal_5);
      },(_ck,_v) => {
        const currVal_4:any = (_v.context.$implicit.Open? 'block': 'none');
        _ck(_v,16,0,currVal_4);
      });
}
export function View_MenuComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),10,'div',[['style',
      'margin-left:-30px;']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵted((null as any),['\n    '])),(_l()(),i0.ɵeld(0,
      (null as any),(null as any),4,'h3',[['class','navigation-title']],(null as any),
      (null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵted((null as any),
      ['Packaging Information Tool / '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
      1,'span',[['style','color: whitesmoke']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i0.ɵted((null as any),['',''])),(_l()(),
      i0.ɵted((null as any),['\n    '])),(_l()(),i0.ɵted((null as any),['\n    '])),
      (_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_MenuComponent_1)),
      i0.ɵdid(802816,(null as any),0,i4.NgForOf,[i0.ViewContainerRef,i0.TemplateRef,
          i0.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i0.ɵted((null as any),
          ['\n']))],(_ck,_v) => {
    var _co:i5.MenuComponent = _v.component;
    const currVal_1:any = _co.menuItems;
    _ck(_v,9,0,currVal_1);
  },(_ck,_v) => {
    var _co:i5.MenuComponent = _v.component;
    const currVal_0:any = _co.appVersion;
    _ck(_v,5,0,currVal_0);
  });
}
export function View_MenuComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),2,'menu',([] as any[]),
      (null as any),(null as any),(null as any),View_MenuComponent_0,RenderType_MenuComponent)),
      i0.ɵprd(512,(null as any),i6.MenuService,i6.MenuService,[i7.Authentication]),
      i0.ɵdid(114688,(null as any),0,i5.MenuComponent,[i6.MenuService,i8.AppConfig],
          (null as any),(null as any))],(_ck,_v) => {
    _ck(_v,2,0);
  },(null as any));
}
export const MenuComponentNgFactory:i0.ComponentFactory<i5.MenuComponent> = i0.ɵccf('menu',
    i5.MenuComponent,View_MenuComponent_Host_0,{},{selectedMenu:'selectedMenu'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// C:/Users/SHR6M3/Development/PackITWebGui/src/$$_gendir/app/menu/menu.component.ngfactory.ts